import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
	mode: 'history',
	routes, // short for routes: routes
	linkActiveClass: 'active',
	scrollBehavior: (to, from, savedPosition) => {
		if (savedPosition) {
			return savedPosition;
		}
		if (to.hash) {
			return { selector: to.hash };
		}
		return { x: 0, y: 0 };
	}
});

router.beforeEach((to, from, next) => {
	const { user } = store.state.commonStore;

	// console.log('From:', from.path);
	// console.log('To:', to.path);

	if (to.path === '/login') {
		next();
	} else if(!user.userId) {
		if (to.path !== '/redirect' && to.path !== '/ssoLogin' && to.path !== '/directLogin' && to.path !== '/reset') {
			next({
				path: '/login'
			});
		}else {
			next();
		}
	} else {
		if (to.path !== from.path) {
			if (user.initYn === 'Y' || user.lastLoginDt === null) {
				if (to.path !== '/reset') {
					next({
						path: '/reset'
					});
				} else {
					next();
				}
			} else {
				next();
			}
		} else {
			next();
		}
	}
});

export default router;
